import React, { useMemo, useState } from "react";
import { useRequestsFeedbacks } from "./hooks/feedbacks.hooks";
import RequestsFeedbacksTable from "./components/DataTable/RequestsFeedbacs";
import {
  RequestFeedback,
  RequestFeedbackFilter,
} from "@/services/interfaces/IFeedbackService";
import RequestFeedbacksFilters from "./components/filters/request-feedbacks.filter";
import { RequestFeedbackModal } from "./components/RequestFeedbackModal";

const PER_PAGE = 10;
type SortBy = NonNullable<RequestFeedbackFilter["sortBy"]>;

export const RequestsFeedbacks: React.FC<{ hotelId: string }> = ({
  hotelId,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState<
    Omit<RequestFeedbackFilter, "sortBy" | "page" | "limit" | "hotelId">
  >({
    roomIds: [],
    serviceIds: [],
    staffIds: [],
    teamIds: [],
    minRating: 1,
  });
  const [sortBy, setSortBy] = useState<SortBy | null>(null);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc" | null>(null);

  const [selectedFeedback, setSelectedFeedback] =
    useState<RequestFeedback | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const feedbacksFilters = useMemo(() => {
    return {
      ...filters,
      page: currentPage,
      limit: PER_PAGE,
      sortBy: sortBy ?? undefined,
      sortOrder: sortOrder ?? undefined,
      hotelId,
    };
  }, [filters, currentPage, sortBy, sortOrder, hotelId]);

  const { data, isLoading } = useRequestsFeedbacks(feedbacksFilters);
  const feedbacks = data?.data ?? [];
  const totalPages = data?.total
    ? Math.max(1, Math.ceil(data?.total / data.limit))
    : 1;

  const handleSort = (field: string) => {
    const newField = field as SortBy;
    if (sortBy !== newField) {
      setSortBy(newField);
      setSortOrder("asc");
    } else {
      if (sortOrder === "asc") setSortOrder("desc");
      else if (sortOrder === "desc") {
        setSortBy(null);
        setSortOrder(null);
      } else setSortOrder("asc");
    }
  };

  const handleRowClick = (feedback: RequestFeedback) => {
    setSelectedFeedback(feedback);
    setIsModalOpen(true);
  };

  return (
    <div className="flex flex-col p-4 gap-4">
      <RequestFeedbacksFilters filters={filters} onChange={setFilters} />

      <RequestsFeedbacksTable
        data={feedbacks}
        isLoading={isLoading}
        sortBy={sortBy}
        sortOrder={sortOrder}
        onSort={handleSort}
        currentPage={currentPage}
        totalPages={totalPages || 1}
        onPageChange={setCurrentPage}
        onRowClick={handleRowClick}
      />

      <RequestFeedbackModal
        feedback={selectedFeedback}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};
